/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React, { useMemo, useRef, useState } from 'react';
import { isComponentOfType } from '../../../helpers/reactElementHelpers';

import useOnClickOutside from '../../../hooks/useOnClickOutside';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../Abstrap/Abstrap';

import PopoverToggle from './PopoverToggle/PopoverToggle';
import PopoverContainer from './PopoverContainer/PopoverContainer';

const propTypes = {
    ...commonPropTypes,
};

const defaultProps = {
    ...commonDefaultProps,
};

const Popover = (props) => {
    const [isDisplayed, setIsDisplayed] = useState(false);
    const currentElement = useRef(null);
    const onClickOutside = () => setIsDisplayed(false);
    const toggleIsDisplayed = () => setIsDisplayed((value) => !value);

    useOnClickOutside(currentElement, onClickOutside);

    const classNames = [
        'c-popover',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];

    const renderingChildren = useMemo(() => (
        React.Children.map(props.children, (child) => {
            if (isComponentOfType(child, PopoverToggle)) {
                return React.cloneElement(child, {
                    key: 'toggle',
                    onClick: () => toggleIsDisplayed(),
                });
            }
            if (isComponentOfType(child, PopoverContainer)) {
                return isDisplayed ? child : React.cloneElement(child, {
                    key: 'container',
                    style: { display: 'none' },
                });
            }
            return child;
        })
    ), [props.children, isDisplayed]);

    return (
        <props.componentClass
            ref={currentElement}
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {renderingChildren}
        </props.componentClass>
    );
};

Popover.propTypes = propTypes;

Popover.defaultProps = defaultProps;

export default Popover;
